/**
 * Angular Import.
 */
import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Import interface.
 */
import { TherapeuticDrug, PharmaInfo } from './../model/eDetailPharmaDetail.model';

/**
 * Constant imports.
 */
import { CONTENT_VISIBILITY } from '../../constants/app.constants';

/**
 * Pharma drug card.
 */
@Component({
  selector: 'app-edetail-drug-card',
  templateUrl: './edetail-drug-card.component.html',
  styleUrls: ['./edetail-drug-card.component.scss']
})
export class EdetailDrugCardComponent {

  /**
   * Pharma drug card data.
   */
  @Input() drugData: TherapeuticDrug;

  /**
   * Pharma drug speciality.
   */
  @Input() speciality?: PharmaInfo;

  /**
   * Output for redirect user to drug detail.
   */
  @Output() public viewDrugDetail = new EventEmitter<{ drugInfo: TherapeuticDrug, etpmId?: number }>();

  /**
   * Content visiblity.
   */
  public contentVisibility = CONTENT_VISIBILITY;

  /**
   * User click on drug card.
   */
  redirectDetail(): void {
    if (this.drugData.flags === null || this.drugData.flags.content_visibility.display === CONTENT_VISIBILITY.VISIBLE) {
      if (this.speciality) {
        this.viewDrugDetail.emit({ drugInfo: this.drugData, etpmId: this.speciality.etpm_id });
      } else {
        this.viewDrugDetail.emit({ drugInfo: this.drugData });
      }
    }
  }
}
